import {SetGetAmountReferrals} from './thunk/setGetAmountReferrals';
import {SetGetReferrals} from './thunk/setGetReferrals';
import {SetGetViewReferrals} from './thunk/setGetViewReferral';
import {SetPostBonusesCreate} from './thunk/setPostBonusesCreate';
import {SetPostBonusesReferralIssue} from './thunk/setPostBonusesReferralIssue';
import {SetPostUpdatePercent} from './thunk/setPostUpdatePercent';

export const Thunks = {
    SetGetAmountReferrals,
    SetGetReferrals,
    SetGetViewReferrals,
    SetPostBonusesCreate,
    SetPostBonusesReferralIssue,
    SetPostUpdatePercent
}